import { render, staticRenderFns } from "./RequestScore.vue?vue&type=template&id=017bc3e8&"
import script from "./RequestScore.vue?vue&type=script&lang=js&"
export * from "./RequestScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports